import {getUsersByLocalId} from '../../../../../crud/users_api/users';
import {getMesasByLocalId} from '../../../../../crud/management_api/mesas';  

  export interface UsersOption {
    id: number;
    name: string;
  }

  export interface MesasOption {
    id: number;
    num: string;
    tag?: string;
  }

  export const getUsersOptions = async () => {
      const userContext = localStorage.getItem('user');
      const localId = userContext != null ? JSON.parse(userContext).local_id : 0;
      const response = await getUsersByLocalId(localId);
      if (response) {
        const data = response.data;
        if (data) {
          const users: UsersOption[] = data.map((users:any) => {
            return {
              id: users.user_id,
              name: users.username,
            };
          });
          return users;
        }
      }
      return [];
    };

    export const getMesasOptions = async () => {
          const userContext = localStorage.getItem('user');
          const localId = userContext != null ? JSON.parse(userContext).local_id : 0;
          const response = await getMesasByLocalId(localId);
          if (response) {
            const data = response.data;
            if (data) {
              const mesas: MesasOption[] = data.map((mesas:any) => {
                return {
                  id: mesas.mesa_id,
                  num: mesas.mesa_number,
                  tag: mesas.mesa_tag,
                };
              });
              return mesas;
            }
          }
          return [];
        };